<template>
	<div class="global-search">
		<div class="global-search-input position-relative">
			<i class="fa-duotone fa-magnifying-glass search-icon"></i>
			<input
				@focus="resultsFlag = true"
				ref="input"
				type="text"
				v-model="search"
				tabindex="0"
				class="form-control search-input"
				placeholder="Search..."
			/>
		</div>
		<div
			v-if="(clients.length > 0 || municipalities.length > 0) && resultsFlag"
			class="global-search-container position-relative"
		>
			<div class="global-search-results">
				<div class="search-result-category" v-if="clients.length > 0">
					<div class="header pt-2 px-3">
						<h6 class="p-0 m-0">Clients</h6>
					</div>
					<div class="body px-3 py-1">
						<template v-for="data in clients">
							<div
								class="search-result-item client-item search-item ps-2 pe-2 py-1 d-flex"
								:key="'client' + data.id"
								role="button"
								@click="goTo('clientsEdit', data.id)"
							>
								<span class="me-2 w-50">{{ data.name }}</span>
								<span class="me-2 w-25">{{ data.county }}</span>
								<span class="w-25 text-end pe-2">{{ data.state_abb }}</span>
							</div>
						</template>
					</div>
				</div>
				<div class="search-result-category" v-if="municipalities.length > 0">
					<div class="header pt-2 px-3">
						<h6 class="p-0 m-0">Municipalities</h6>
					</div>
					<div class="body px-3 py-1">
						<template v-for="data in municipalities">
							<div
								class="search-result-item municipality-item search-item ps-2 pe-2 py-1 d-flex"
								:key="'municipality' + data.id"
								role="button"
								@click="goTo('municipalityEdit', data.id)"
							>
								<span class="me-2 w-50">{{ data.full_name }}</span>
								<span class="me-2 w-25">{{ data.county }}</span>
								<span class="w-25 text-end pe-2">{{ data.state }}</span>
							</div>
						</template>
					</div>
				</div>
				<button @click="resetSearch()" class="btn btn-link float-end me-2 mb-2">cancel</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../api/index'
import { handleErrors } from '../actions/helpers'
export default {
	name: 'GlobalSearch',
	//props: ['user'],
	data() {
		return {
			loading: false,
			municipalities: [],
			clients: [],
			clientContacts: [],
			contacts: [],
			deliveries: [],
			campaigns: [],
			search: '',
			resultsFlag: false,
		}
	},
	created() {},
	computed: {
		...mapState(['storageUrl']),
	},
	methods: {
		getSearchResults() {
			this.loading = true
			this.params = {
				search: this.search,
			}
			restApi
				.get(`/helper/global-search`, { params: this.params })
				.then(({ data }) => {
					this.municipalities = data.municipalities
					this.clients = data.clients
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		goTo(resultsType, resultId) {
			this.$router.push({ name: resultsType, params: { id: resultId } })
			this.municipalities = []
			this.clients = []
			this.search = ''
		},
		resetSearch() {
			this.municipalities = []
			this.clients = []
			this.search = ''
		},
	},
	watch: {
		search: function() {
			if (this.search.length >= 2) {
				if (!this.loading) {
					this.getSearchResults()
				}
			} else {
				this.municipalities = []
				this.clients = []
			}
		},
	},
}
</script>

<style lang="scss">
.global-search-input {
	position: relative;
	
	.search-icon {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		color: #64748b;
		font-size: 16px;
		z-index: 2;
		pointer-events: none;
	}
}

.search-input {
	background: #ffffff;
	border: 1px solid #e0e1e1 !important;
	border-radius: 8px;
	padding-right: 45px;
	padding-left: 12px;
	transition: all 0.2s ease;
	box-shadow: none !important;
	
	&:focus {
		border-color: #d1d5db !important;
		box-shadow: none !important;
		outline: none;
	}
	
	&.focus-visible {
		.global-search-results {
			display: block;
		}
	}
}

.global-search-container {
}

.global-search-results {
	background-color: white;
	position: absolute;
	width: 100%;
	z-index: 999;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
	border: 2px solid whitesmoke;
	.search-result-item {
		&:hover {
			background-color: whitesmoke;
			border-radius: 5px;
		}
	}
}
</style>
